import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/IndexOptimized";
import { routeHead } from "@/lib/seo/route-head";
import { HERO_PRELOAD } from "@/lib/seo/hero-preload";

export const Route = createFileRoute("/uk/")({
  head: () => {
    const base = routeHead("/uk/");
    return { ...base, links: [...(base.links ?? []), ...HERO_PRELOAD] };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Index />
  );
}
